import VueRouter from 'vue-router'

import store from '../store'

import Config from '../config'


// eslint-disable-next-line no-unused-vars
import Home from '../views/Home.vue'
import HomeEnel from '../views/HomeEnel.vue'
import HomeWind from '../views/HomeWind.vue'
import HomeAcea from '../views/HomeAcea.vue'
import Login from '../views/Login.vue'
import PasswordRestore from '../views/PasswordRestore.vue'
import PasswordRestoreConfirm from '../views/PasswordRestoreConfirm.vue'
import Signup from '../views/Signup.vue'
import SignupConfirm from '../views/SignupConfirm.vue'

import Terms from '../views/Terms.vue'
import Warnings from '../views/Warnings.vue'
import Privacy from '../views/Privacy.vue'

import PromoCode from '../views/PromoCode.vue'
import PromoCodeSignup from '../views/PromoCodeSignup.vue'
import Profile from '../views/Profile.vue'

const router = new VueRouter({
	mode          : Config.url ? 'history' : undefined,
	scrollBehavior: () => ({ x: 0, y: 0 }),
	routes        : [
		{
			path     : '/',
			name     : 'home',
			component: HomeAcea
			//component: Home
		},
		{
			path     : '/test-enel',
			name     : 'home-enel',
			component: HomeEnel
			/*redirect: () => {
				return { path: '/'}
			}*/
		},
		{
			path     : '/test-wind',
			name     : 'home-wind',
			component: HomeWind
			/*redirect: () => {
				return { path: '/'}
			}*/
		},
		{
			path     : '/test-acea',
			name     : 'home-acea',
			component: HomeAcea
			/*redirect: () => {
				return { path: '/'}
			}*/
		},
		{
			path     : '/promo-code',
			name     : 'promo',
			component: PromoCode
		},
		{
			path     : '/promo-code-signup',
			name     : 'promosignup',
			component: PromoCodeSignup,
			meta     : { hideNavbar: true, hideFooter: true }
		},
		{
			path     : '/login',
			name     : 'login',
			component: Login,
			meta     : { hideNavbar: true, hideFooter: true }
		},
		{
			path     : '/password-restore',
			name     : 'password',
			component: PasswordRestore,
			meta     : { hideNavbar: true, hideFooter: true }
		},
		{
			path     : '/password-restore-confirm',
			name     : 'password-confirm',
			component: PasswordRestoreConfirm,
			meta     : { hideNavbar: true, hideFooter: true }
		},
		{
			path     : '/signup',
			name     : 'signup',
			component: Signup,
			meta     : { hideNavbar: true, hideFooter: true }
		},
		{
			path     : '/signup-confirm',
			name     : 'signup-confirm',
			component: SignupConfirm,
			meta     : { hideNavbar: true, hideFooter: true }
		},
		{
			path     : '/terms',
			component: Terms
		},
		{
			path     : '/warnings',
			component: Warnings
		},
		{
			path     : '/privacy',
			component: Privacy
		},
		{
			path     : '/profile',
			component: Profile,
			name     : 'profile',
			meta     : {
				requiresAuth       : true,
				hideNavbarIfPayment: true,
				hideFooterIfPayment: true
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	window.previousUrl = from.path
	if (to.name && to.name.indexOf('landing') === 0) {
		document.documentElement.classList.add('is-scrolled-top')
		document.getElementsByTagName("BODY")[0].classList.add('page-home')

	} else if (to.name !== 'home' && to.name !== 'home-enel' && to.name !== 'home-wind' && to.name !== 'company') {
		document.getElementsByTagName("BODY")[0].classList.remove('page-header')
		document.documentElement.classList.remove('is-scrolled-top')
	} else {
		document.documentElement.classList.add('is-scrolled-top')

		if (to.name === 'home' || to.name === 'home-enel') {
			document.getElementsByTagName("BODY")[0].classList.add('page-home')
		} else {
			document.getElementsByTagName("BODY")[0].classList.remove('page-home')
		}

		if (to.name === 'profile') {
			document.getElementsByTagName("BODY")[0].classList.add('page-profile')
		} else {
			document.getElementsByTagName("BODY")[0].classList.remove('page-profile')
		}
	}

	if (document.activeElement) {
		document.activeElement.blur()
	}

	if (to.matched.some(record => record.meta.requiresAuth)) {
		store.dispatch('auth/isAuthenticationValid').then((result) => {
			if (result) {
				return next()
			}
			next('/')
		}).catch(() => {
			next('/')
		})
	} else {
		next()
	}
})

export default router
